<template>
  <div class="container mt-25">
    <h3 class="bold-font center">Check Payment</h3>
    <section v-show="!showSuccess">
      <form enctype="multipart/form-data" novalidate ref="form">
        <div class='row'>

          <div class='col s6' v-if="amountEditable ">
            <label>Amount, USD</label>
            <input 
              name='amount'
              autofocus
              v-model='amount'
              step="0.01"
              type="number"
              inputmode="decimal"
              pattern="\d*"
              v-validate="'min_value:0.51|required'"
              class='inputText'
              lang="en-001">

            <span class='red-text small-font' v-show='errors.first("amount")'>The Amount field must be 0.51 or more.</span>
          </div>
          <div class='col s6' v-else>
            <h3 class="bold-font center">Check: {{amount | currency}}</h3>

            <div class='large-font mt-5 center'>
              to: {{businessName}}
            </div>
          </div>
        </div>
        <div class='row'>
          <div class='col s12 m6'>
            <label>Note (optional)</label>
            <input v-model="note" name="note">
          </div>
          <div class='col s12 m6'>
            <div v-if="presetInvoice.length > 0" class="large-font center mt-25">
              <i class="fas fa-file-invoice prefix grey-text"></i>
              Invoice: <span class="bold-font">{{invoice}}</span>
            </div>
            <div v-else class="input-field">
              <i class="fas fa-file-invoice prefix grey-text"></i>
              <input name="invoice" id="invoice" type="text" v-model="invoice" ref="invoice">

              <label for="invoice">Invoice</label>
            </div>
          </div>
        </div>

        <image-uploader
            :debug="1"
            :maxWidth="900"
            :quality="0.8"
            :autoRotate=true
            outputFormat="blob"
            :preview=false
            :className="['file-upload', { 'fileinput--loaded' : hasImage }]"
            :capture="false"
            accept="image/*"
            doNotResize="['gif', 'svg']"
            @input="setImage"
            @onUpload="startImageResize"
            onComplete="endImageResize"
          >

          <label for="fileInput" slot="upload-label">
            <div class="btn-large wide-btn" :disabled="disabled">
              <i class="fas fa-camera"></i> 
              <span class="upload-caption">{{ hasImage ? 'Replace' : 'Check' }}</span>
            </div>
          </label>

        </image-uploader>

        <section class="grey-text small-font center" v-show="showSubmitButton">
          <img :src="src" alt="Check image" height="90px" class="mt-10" />
          <div class="btn-large wide-btn mt-10" @click="submit" :disabled="disabled">
            <span v-if="disabled">
              <i class="fas fa-spinner fa-spin grey-text"></i> 
              <span>Processing...</span>
            </span>
            <span v-else>
              Submit
            </span>
          </div>
        </section>
      </form>
    </section>
    <section v-show="showSuccess" class="mt-25 center">
      <h3 class='emerald bold-font'>
        <i class="fas fa-check fa-3x"></i><br>
        Successfully Paid
      </h3>
    </section>
  </div>
</template>
<script>
  export default {
    props: ['paymentType', 'presetAmount', 'presetInvoice', 'presetNote', 'amountEditable', 'invoiceEditable', 'noteEditable', 'businessName', 'merchantQid', 'showTips', 'checkoutSessionId', 'custom'],
    data() {
      return {
        amount: this.presetAmount,
        invoice: this.presetInvoice,
        note: this.presetNote,
        disabled: false,
        src: null,
        hasImage: false,
        image: null,
        showSubmitButton: false,
        apiResponse: null,
        showSuccess: false
      }
    },
    methods: {
      submit() {
        this.disabled = true
        this.$validator.validateAll().then((result) => {
          if (result) {
            let formData = new FormData(this.$refs.form)
            formData.append("check", this.image)
            formData.append("checkout_session_id", this.checkoutSessionId)
            formData.append("custom", this.custom)
            formData.append("amount", this.amount)
            formData.append("invoice", this.invoice)

            this.$http.post("/api/v1/public/checkout_sessions/check_payments", formData).then(response => {
              this.showSuccess = true
              this.notifySuccess("Transaction successfully processed")
            }, error => {
              this.disabled = false
              this.errorHandler(error)
            })
          } else {
            this.disabled = false
            this.notifyError("Please complete all required fields!")
          }
        })
      },
      startImageResize() {
        // Some image processing
      },
      setImage(image) {
        this.hasImage = true
        this.image = image

        // Prepare image preview
        var reader = new FileReader();
        reader.readAsDataURL(image); 
        reader.onloadend = res => {
          this.src = reader.result;                
        }
        this.showSubmitButton = true
      }
    },
    computed: {
      chargeParams() {
        return {
          amount: this.amount,
          note: this.note,
          invoice: this.invoice,
          checkout_session_id: this.checkoutSessionId,
          custom: this.custom
        }
      }
    }
  }
</script>
<style>
  input#fileInput {
    display: none;
  }
</style>
